import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import navConfig from './NavConfig';

import {
  Link,
  matchPath,
  useLocation
} from 'react-router-dom';


function useRouteMatch(patterns) {
  const { pathname } = useLocation();

  for (let i = 0; i < patterns.length; i += 1) {
    const pattern = patterns[i];
    const possibleMatch = matchPath(pattern, pathname);
    if (possibleMatch !== null) {
      return possibleMatch;
    }
  }

  return null;
}

export default function Navbar() {
  const routeMatch = useRouteMatch(navConfig.paths);
  const currentTab = routeMatch?.pattern?.path;

  return (
    <Tabs variant="scrollable" scrollButtons="auto" value={currentTab}>
      {navConfig.items.map((item, index) => <Tab key={index} label={item.title} value={item.path} to={item.path} icon={item.icon} style={{ color: 'inherit' }} component={Link}/>)}
    </Tabs>
  );
}


